import { ModalContainerService } from './../../base-classes/containers/services/modal-container.service';
import { OnInit, Input } from '@angular/core';
import { BaseDataService } from './../../base-services/base-data.service';
import { BaseDetailListComponent } from './../../base-classes/base-list-component-v2';
import { BaseEntity } from './../../base-models/base-entity';
import { Component } from '@angular/core';
import { ModelData } from '../../base-models/model-data';
import { ModalSize } from '../../base-models/modal-size';
import { ParentProperty } from '../../base-models/parent-property';
import { ModalService } from '../../base-services/modal.service';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { DefaultButtonsConfig } from '../../base-models/default-buttons-config';
import { NotificationService } from '../../base-services/notification-service';
// import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'yt-fw-default-detail-list-modal',
    templateUrl: './default-detail-list.component.html',
    providers: [
        ModalContainerService,
        ModalService
    ]
})
export class DefaultDetailListModalComponent<T extends BaseEntity> extends BaseDetailListComponent<T> implements OnInit{
    // constructor(
    //     protected baseDataService: BaseDataService,
    //     protected containerService: ModalContainerService<T>,
    //     protected translateService: TranslateService,
    //     protected modalService: ModalService,
    //     protected notificationsService: NotificationsService
    // )
    // {
    //     super(baseDataService, containerService, translateService, modalService, notificationsService);
    // }

    constructor(
        protected baseDataService: BaseDataService,
        protected containerService: ModalContainerService<T>,
        protected translateService: TranslateService,
        protected modalService: ModalService,
        protected toastrService: NotificationService
    )
    {
        super(baseDataService, containerService, translateService, modalService, toastrService);
    }

    tableConfig: {};

    @Input() Disabled: boolean = false;

    ngOnInit(){
        super.ngOnInit();
        this.tableConfig = {
            EditIcon: {
                Visible: true
            },
            DeleteIcon: {
                Visible: true
            },
            PrintIcon: {
                Visible: false
            },
            DefaultSortKey: this._model.SortBy,
            DefaultSortReverse: this._model.SortReverse,
            ShowIndex: false,
            ShowDefaultListButtons: true,
            ShowCheckBoxes: true,
            DefaultListButtonsConfig: this._model.DefaultListButtonsConfig,
            IsModal: true
        }
    }

    AddItem(){
        let modelData = new ModelData(null);
        modelData.MainList = this._model;
        modelData.ModalSize = this._model.ModalSize;
        modelData.UpdateComponent = this._model.UpdateComponent;
        this.containerService.AddItem(modelData, new ParentProperty(this._parentPropertyName, this._parentPropertyValue), this.Parameters);
    }

    EditItem(item: T){
        let modelData = new ModelData(null);
        modelData.MainList = this._model;
        modelData.ModalSize = this._model.ModalSize;
        modelData.UpdateComponent = this._model.UpdateComponent;
        this.containerService.EditItem(modelData, item.ID, new ParentProperty(this._parentPropertyName, this._parentPropertyValue), this.Parameters);
        // this.containerService.EditItem(modelData, item.ID, item.Useridlk, new ParentProperty(this._parentPropertyName, this._parentPropertyValue), this.Parameters);
    }

    SelectItem(item: T){
    }
}
